/** Keeps Help "Go to" flows alive after pages strip `?helpGuide=` from the URL. */

const HELP_GUIDE_SESSION_KEY = "esgHelpGuideBypass";
const TRAINING_DETAIL_PHASE_KEY = "esgHelpTrainingDetailPhase";
const TRAINING_OVERVIEW_PHASE_KEY = "esgHelpTrainingOverviewPhase";

export type TrainingDetailHelpPhase = "view" | "summary" | "filter" | "table";

/** Full "Go to Employee Training" tour phases. */
export type TrainingOverviewHelpPhase =
  | "filter"
  | "table"
  | "viewHistory"
  | "detailSummary"
  | "detailFilter"
  | "detailTable"
  | "addTraining"
  | "recordForm"
  | "recordSave";

export function markHelpGuideActive(guide: string): void {
  if (!guide) return;
  sessionStorage.setItem(HELP_GUIDE_SESSION_KEY, guide);
}

export function clearHelpGuideActive(): void {
  sessionStorage.removeItem(HELP_GUIDE_SESSION_KEY);
  sessionStorage.removeItem(TRAINING_DETAIL_PHASE_KEY);
  sessionStorage.removeItem(TRAINING_OVERVIEW_PHASE_KEY);
}

export function isHelpGuideBypassActive(): boolean {
  return Boolean(sessionStorage.getItem(HELP_GUIDE_SESSION_KEY));
}

export function getActiveHelpGuide(): string | null {
  return sessionStorage.getItem(HELP_GUIDE_SESSION_KEY);
}

export function setTrainingDetailHelpPhase(phase: TrainingDetailHelpPhase): void {
  sessionStorage.setItem(TRAINING_DETAIL_PHASE_KEY, phase);
}

export function getTrainingDetailHelpPhase(): TrainingDetailHelpPhase {
  const raw = sessionStorage.getItem(TRAINING_DETAIL_PHASE_KEY);
  if (raw === "summary" || raw === "filter" || raw === "table" || raw === "view") {
    return raw;
  }
  return "view";
}

export function setTrainingOverviewHelpPhase(phase: TrainingOverviewHelpPhase): void {
  sessionStorage.setItem(TRAINING_OVERVIEW_PHASE_KEY, phase);
}

export function getTrainingOverviewHelpPhase(): TrainingOverviewHelpPhase {
  const raw = sessionStorage.getItem(TRAINING_OVERVIEW_PHASE_KEY);
  const allowed: TrainingOverviewHelpPhase[] = [
    "filter",
    "table",
    "viewHistory",
    "detailSummary",
    "detailFilter",
    "detailTable",
    "addTraining",
    "recordForm",
    "recordSave",
  ];
  if (raw && (allowed as string[]).includes(raw)) {
    return raw as TrainingOverviewHelpPhase;
  }
  return "filter";
}

export function isOverviewDetailPhase(
  phase: TrainingOverviewHelpPhase,
): phase is "detailSummary" | "detailFilter" | "detailTable" {
  return (
    phase === "detailSummary" ||
    phase === "detailFilter" ||
    phase === "detailTable"
  );
}
